module.exports = __webpack_public_path__ + "static/media/manual-credit@3x.1153b232.png";